function encodePathSegment(value: string): string {
  return encodeURIComponent(value);
}

function normalizeOrigin(origin: string): string {
  return origin.replace(/\/+$/, "");
}

export function buildAbsoluteShareUrl(origin: string, path: string): string {
  return new URL(path, `${normalizeOrigin(origin)}/`).toString();
}

export function buildTodaySharePath(issueDate?: string): string {
  return issueDate
    ? `/share/today/${encodePathSegment(issueDate)}`
    : "/share/today";
}

export function buildTodayShareImagePath(issueDate?: string): string {
  return issueDate
    ? `/share/today/${encodePathSegment(issueDate)}.png`
    : "/share/today.png";
}

export function buildTodayBrowsePath(issueDate?: string): string {
  return issueDate ? `/today?date=${encodeURIComponent(issueDate)}` : "/today";
}

export function buildTrendsSharePath(): string {
  return "/share/trends";
}

export function buildTrendsShareImagePath(): string {
  return "/share/trends.png";
}

export function buildTrendsBrowsePath(): string {
  return "/trends";
}

export function buildDiscussionSharePath(
  discussionId: number | string,
): string {
  return `/share/discussions/${encodePathSegment(String(discussionId))}`;
}

export function buildDiscussionShareImagePath(
  discussionId: number | string,
): string {
  return `/share/discussions/${encodePathSegment(String(discussionId))}.png`;
}

export function buildDiscussionBrowsePath(
  discussionId: number | string,
): string {
  return `/discussions/${encodePathSegment(String(discussionId))}`;
}
